import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { AuthService } from '../auth/auth.service';

/**
 * HTTP interceptor that attaches the JWT access token as an
 * Authorization: Bearer header to all outgoing requests.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const auth = inject(AuthService);

    return from(auth.getToken()).pipe(
        switchMap((token) => {
            if (token) {
                const cloned = req.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                return next(cloned);
            }
            return next(req);
        }),
    );
};
